export default __webpack_public_path__ + "static/cat_shield1-201796b8812c356989f029f18ae92f78.jpg";